export const setLocalStorage = ( userId, guid_user ,displayName, avatar, email, token, scopes ) => {

   localStorage.setItem(`user_${ process.env.REACT_APP_NAME_NOTARY }`, JSON.stringify({
      userId,
      guid_user,
      token,
      email,
      avatar,
      displayName,
      scopes
   }));
}


export const setRemoveLocalStorage = () => {
  let item = `user_${ process.env.REACT_APP_NAME_NOTARY }`;
  localStorage.removeItem(item);
}

export const getItemLocalStorage = ( _key ) => {
   let item = `user_${ process.env.REACT_APP_NAME_NOTARY }`;

   if ( typeof(localStorage.getItem(item)) !== 'undefined' ) {
     let value_final = "";
     JSON.parse(localStorage.getItem(item), ( key, value ) => {
       if ( key === _key ) {
         value_final = value;
       }
     });
     return value_final;
   }
}